import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { SourcesFormComponent } from '../sources-form/sources-form.component';

export interface SourcesDialogData {
  sources: (string | null)[];
  maxSourceItems?: number;
  readonly?: boolean;
}

export interface SourcesDialogResult {
  sources: (string | null)[];
  action: 'save' | 'cancel';
}

@Component({
  selector: 'app-sources-dialog',
  standalone: true,
  imports: [CommonModule, SourcesFormComponent, ButtonModule],
  templateUrl: './sources-dialog.component.html',
})
export class SourcesDialogComponent implements OnInit {
  sources: (string | null)[] = [];
  maxSourceItems = 5;
  readonly = false;
  currentSources: (string | null)[] = [];
  isFormValid = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private config: DynamicDialogConfig<SourcesDialogData>,
  ) {}

  ngOnInit() {
    const data = this.config.data;
    if (data) {
      this.sources = data.sources || [null];
      this.maxSourceItems = data.maxSourceItems || 5;
      this.readonly = data.readonly || false;
      this.currentSources = [...this.sources];
    }
  }

  onSourcesChange(sources: (string | null)[]) {
    this.currentSources = sources;
  }

  onFormValidityChange(isValid: boolean) {
    this.isFormValid = isValid;
  }

  onSave() {
    const result: SourcesDialogResult = {
      sources: this.currentSources,
      action: 'save',
    };
    this.dialogRef.close(result);
  }

  onCancel() {
    const result: SourcesDialogResult = {
      sources: this.sources, // Return original sources
      action: 'cancel',
    };
    this.dialogRef.close(result);
  }
}
